export const getTooltipContentByStatus = (status: string) => {
    switch (status) {
        case "Past Due":
            return "This is overdue";
        case "Time Limit Exceeded":
            return "You've exceeded the allotted time for completing this";
        case "Not Attended":
        case "Absent":
            return "You did not attend the session at all";
        case "Late":
            return "You joined the session 15-minute after it began";
        case "Completed":
        case "Complete":
            return "You've successfully completed this";
        case "Not Started":
            return "You haven't started this yet";
        case "Attended":
            return "You attended the session on time";
        case "Watched Recording":
        case "Viewed Recording":
            return "You missed the live session but have watched the recorded version";
        case "In Progress":
        case "In-Progress":
            return "You've started this but haven't finished it yet";
        default:
            return "You haven't started this yet";
    }
};